import React, { useState } from 'react'
import {
  Input,
  Popover,
  PopoverHandler,
  PopoverContent,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Drawer,
} from "@material-tailwind/react";

import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

export default function MenuBar(props) {
  const wallet = useSelector((state) => state.wallet);
  const { t, i18n } = useTranslation();
  const { tab, handle, openRightMenu, menuIndex, setMenuIndex, closeRightMenu, rightMenu, subMenuIndex, setSubMenuIndex } = props;
  const [openUniverseMenu, setOpenUniverseMenu] = useState(false);
  const [openPresaleMenu, setOpenPresaleMenu] = useState(false);
  const [openIdoMenu, setOpenIdoMenu] = useState(false);
  const [openTapMenu, setOpenTapMenu] = useState(false);
  const [triSubmenuIndex, setTriSubmenuIndex] = useState("");

  return (
    <Drawer
      placement="right"
      open={rightMenu}
      onClose={closeRightMenu}
      className="py-4 px-2 bg-black text-white overflow-y-scroll"
    >
      <div className="flex flex-col gap-5 px-3">
        <div className="flex flex-row justify-between items-center mt-3 mb-6">
          <div className="text-primary font-bold text-3xl">
            {t("Menu")}
          </div>
          <XMarkIcon
            strokeWidth={2}
            className="h-6 w-6 cursor-pointer"
            onClick={closeRightMenu}
          />
        </div>
        <div
          className={`${
            tab == 0 ? "text-primary bg-gray-900" : "text-white"
          } hover:bg-gray-900 rounded-md px-4 py-2 font-semibold cursor-pointer hover:text-primary text-lg`}
          onClick={() => {
            handle(0);
          }}
        >
          {t("Wallet")}
        </div>
        <div className="flex flex-col">
          <div
            className={`flex flex-row justify-between items-center ${
              tab == 1 || tab == 19
                ? "text-primary bg-gray-900"
                : "text-white"
            } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
            onClick={() => {
              menuIndex == "register"
                ? setMenuIndex("")
                : setMenuIndex("register");
            }}
          >
            <div className={`font-semibold text-lg`}>
              {t("Register")}
            </div>
            <ChevronUpIcon
              strokeWidth={4}
              className={`font-bold h-5 w-5 transition-transform rotate-180`}
            />
          </div>
          <div
            className={`flex flex-col gap-1 ml-3 mt-2 transition-all duration-300 overflow-hidden ${
              menuIndex == "register" ? "h-[80px]" : "h-0"
            }`}
          >
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(19);
              }}
            >
              {t("DOMAIN NAMES")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(1);
              }}
            >
              {t("UNIVERSE NAMES")}
            </div>
          </div>
        </div>
        <div
          className={`${
            tab == 2 ? "text-primary bg-gray-900" : "text-white"
          } hover:bg-gray-900 rounded-md px-4 py-2  font-semibold cursor-pointer hover:text-primary text-lg`}
          onClick={() => {
            handle(2);
          }}
        >
          {t("Explorer")}
        </div>
        {wallet.nostrPaymentAddress != "" ? (
          <div
            className={`${
              tab == 3 ? "text-primary bg-gray-900" : "text-white"
            } hover:bg-gray-900 rounded-md px-4 py-2  font-semibold cursor-pointer hover:text-primary text-lg`}
            onClick={() => {
              handle(3);
            }}
          >
            {t("My Profile")}
          </div>
        ) : (
          <></>
        )}
        <div
          className={`${
            tab == 4 ? "text-primary bg-gray-900" : "text-white"
          } hover:bg-gray-900 rounded-md px-4 py-2  font-semibold cursor-pointer hover:text-primary text-lg`}
          onClick={() => {
            handle(4);
          }}
        >
          {t("Index")}
        </div>
        <div className="flex flex-col">
          <div
            className={`flex flex-row justify-between items-center ${
              tab == 19 || tab == 17 || tab == 5 || tab == 7 || tab == 14 || tab == 13
                ? "text-primary bg-gray-900"
                : "text-white"
            } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
            onClick={() => {
              menuIndex == "inscribe"
                ? setMenuIndex("")
                : setMenuIndex("inscribe");
            }}
          >
            <div className={`font-semibold text-lg`}>
              {t("Inscribe")}
            </div>
            <ChevronUpIcon
              strokeWidth={4}
              className={`font-bold h-5 w-5 transition-transform rotate-180`}
            />
          </div>
          <div
            className={`flex flex-col gap-1 ml-3 mt-2 transition-all duration-300 overflow-hidden ${
              menuIndex == "inscribe" ? subMenuIndex == "universe" ? "h-[320px]" : "h-[240px]" : "h-0"
            }`}
          >
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(19);
              }}
            >
              {t("DOMAIN NAMES")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(25);
              }}
            >
              {t("ALKANES")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(28);
              }}
            >
              {t("OP_RETURN")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(13);
              }}
            >
              {t("RUNES")}
            </div>
            <div className="flex flex-col">
              <div
                className={`flex flex-row justify-between items-center ${
                  tab == 5 || tab == 7 || tab == 14
                    ? "text-primary bg-gray-900"
                    : "text-white"
                } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
                onClick={() => {
                  subMenuIndex == "universe"
                    ? setSubMenuIndex("")
                    : setSubMenuIndex("universe");
                }}
              >
                <div className={`cursor-pointer hover:text-primary`}>
                UNIVERSE
                </div>
                <ChevronUpIcon
                  strokeWidth={4}
                  className={`font-bold h-5 w-5 transition-transform rotate-180`}
                />
              </div>
              <div
                className={`flex flex-col gap-3 ml-7 mt-2 transition-all duration-300 overflow-hidden ${
                  subMenuIndex == "universe" ? "h-[100px]" : "h-0"
                }`}
              >
                <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                  handle(5);
                }}>
                  $TAPZERO
                </div>
                <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                  handle(7);
                }}>
                  $iSTAMPS
                </div>
                <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                  handle(14);
                }}>
                  $RUNEZERO
                </div>
              </div>
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(17);
              }}
            >
              {t("DUST-20")}
            </div>
          </div>
        </div>
        <div
          className={`${
            tab == 6 ? "text-primary bg-gray-900" : "text-white"
          } hover:bg-gray-900 rounded-md px-4 py-2  font-semibold cursor-pointer hover:text-primary text-lg`}
          onClick={() => {
            handle(6);
          }}
        >
          {t("Trade")}
        </div>
        <div className="flex flex-col">
          <div
            className={`flex flex-row justify-between items-center ${
              tab == 11 || tab == 8 || tab == 15 || tab == 21 || tab == 20
                ? "text-primary bg-gray-900"
                : "text-white"
            } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
            onClick={() => {
              menuIndex == "tools"
                ? setMenuIndex("")
                : setMenuIndex("tools");
            }}
          >
            <div className={`font-semibold text-lg`}>
              {t("Tools")}
            </div>
            <ChevronUpIcon
              strokeWidth={4}
              className={`font-bold h-5 w-5 transition-transform rotate-180`}
            />
          </div>
          <div
            className={`flex flex-col gap-1 ml-3 mt-2 transition-all duration-300 overflow-hidden ${
              menuIndex == "tools" ? subMenuIndex == "presale" || subMenuIndex == "ido" || subMenuIndex == "claim" ? triSubmenuIndex == "brc20" ? "h-[450px]" :"h-[400px]" : "h-[350px]" : "h-0"
            }`}
          >
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(8);
              }}
            >
              {t("CHAT")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(11);
              }}
            >
              {t("AIRDROP")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(15);
              }}
            >
              {t("TAP2BRC20")}
            </div>
            <div
              className="px-4 py-2 cursor-pointer hover:text-primary"
              onClick={() => {
                handle(16);
              }}
            >
              {t("LAUNCHPAD")}
            </div>
            <div className="flex flex-col">
              <div
                className={`flex flex-row justify-between items-center ${
                  tab == 21 || tab == 22
                    ? "text-primary bg-gray-900"
                    : "text-white"
                } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
                onClick={() => {
                  subMenuIndex == "presale"
                    ? setSubMenuIndex("")
                    : setSubMenuIndex("presale");
                }}
              >
                <div className={`cursor-pointer hover:text-primary`}>
                  PRESALE
                </div>
                <ChevronUpIcon
                  strokeWidth={4}
                  className={`font-bold h-5 w-5 transition-transform rotate-180`}
                />
              </div>
              <div
                className={`flex flex-col gap-1 ml-7 mt-2 transition-all duration-300 overflow-hidden ${
                  subMenuIndex == "presale" ? triSubmenuIndex == "brc20" ? "h-[100px]" : "h-[50px]" : "h-0"
                }`}
              >
                <div
                  className={`flex flex-row justify-between items-center ${
                    tab == 20
                      ? "text-primary bg-gray-900"
                      : "text-white"
                  } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
                  onClick={() => {
                    triSubmenuIndex == "brc20"
                      ? setTriSubmenuIndex("")
                      : setTriSubmenuIndex("brc20");
                  }}
                >
                  <div className={`cursor-pointer hover:text-primary`}>
                  BRC20
                  </div>
                  <ChevronUpIcon
                    strokeWidth={4}
                    className={`font-bold h-5 w-5 transition-transform rotate-180`}
                  />
                </div>
                <div
                  className={`flex flex-col gap-3 ml-10 mt-2 transition-all duration-300 overflow-hidden ${
                    triSubmenuIndex == "brc20" ? "h-[50px]" : "h-0"
                  }`}
                >
                  {/* <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                    handle(21);
                  }}>
                    🜟
                  </div> */}
                  <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                    handle(22);
                  }}>
                    🝏
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <div
                className={`flex flex-row justify-between items-center ${
                  tab == 20
                    ? "text-primary bg-gray-900"
                    : "text-white"
                } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
                onClick={() => {
                  subMenuIndex == "ido"
                    ? setSubMenuIndex("")
                    : setSubMenuIndex("ido");
                }}
              >
                <div className={`cursor-pointer hover:text-primary`}>
                IDO
                </div>
                <ChevronUpIcon
                  strokeWidth={4}
                  className={`font-bold h-5 w-5 transition-transform rotate-180`}
                />
              </div>
              <div
                className={`flex flex-col gap-3 ml-7 mt-2 transition-all duration-300 overflow-hidden ${
                  subMenuIndex == "ido" ? "h-[50px]" : "h-0"
                }`}
              >
                <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                  handle(20);
                }}>
                  BRC20
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <div
                className={`flex flex-row justify-between items-center ${
                  tab == 23 || tab == 24
                    ? "text-primary bg-gray-900"
                    : "text-white"
                } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
                onClick={() => {
                  subMenuIndex == "claim"
                    ? setSubMenuIndex("")
                    : setSubMenuIndex("claim");
                }}
              >
                <div className={`cursor-pointer hover:text-primary`}>
                  CLAIM
                </div>
                <ChevronUpIcon
                  strokeWidth={4}
                  className={`font-bold h-5 w-5 transition-transform rotate-180`}
                />
              </div>
              <div
                className={`flex flex-col gap-1 ml-7 mt-2 transition-all duration-300 overflow-hidden ${
                  subMenuIndex == "claim" ? triSubmenuIndex == "brc20" ? "h-[130px]" : "h-[100px]" : "h-0"
                }`}
              >
                <div
                  className={`flex flex-row justify-between items-center ${
                    tab == 20
                      ? "text-primary bg-gray-900"
                      : "text-white"
                  } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
                  onClick={() => {
                    triSubmenuIndex == "brc20"
                      ? setTriSubmenuIndex("")
                      : setTriSubmenuIndex("brc20");
                  }}
                >
                  <div className={`cursor-pointer hover:text-primary`}>
                  BRC20
                  </div>
                  <ChevronUpIcon
                    strokeWidth={4}
                    className={`font-bold h-5 w-5 transition-transform rotate-180`}
                  />
                </div>
                <div
                  className={`flex flex-col gap-3 ml-10 mt-2 transition-all duration-300 overflow-hidden ${
                    triSubmenuIndex == "brc20" ? "h-[100px]" : "h-0"
                  }`}
                >
                  <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                    handle(23);
                  }}>
                    🜷
                  </div>
                  <div className="text-md text-white hover:text-primary cursor-pointer" onClick={() => {
                    handle(24);
                  }}>
                    TAP
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
          <div
            className={`flex flex-row justify-between items-center ${
              tab == 1 || tab == 19
                ? "text-primary bg-gray-900"
                : "text-white"
            } hover:bg-gray-900 rounded-md px-4 py-2 cursor-pointer hover:text-primary`}
            onClick={() => {
              menuIndex == "alkanes"
                ? setMenuIndex("")
                : setMenuIndex("alkanes");
            }}
          >
            <div className={`font-semibold text-lg`}>
              {t("Alkanes")}
            </div>
            <ChevronUpIcon
              strokeWidth={4}
              className={`font-bold h-5 w-5 transition-transform rotate-180`}
            />
          </div>
          <div
            className={`flex flex-col gap-1 ml-3 mt-2 transition-all duration-300 overflow-hidden ${
              menuIndex == "alkanes" ? "h-[260px]" : "h-0"
            }`}
            >
              <div
                className="px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  handle(25);
                }}
              >
                {t("MINT")}
              </div>
              <div
                className="px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  handle(26);
                }}
              >
                {t("EXPLORER")}
              </div>
              <div
                className="px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  window.open('https://launchpad.bitcoinuniverse.io', '_blank')
                }}
              >
                {t("LAUNCHPAD")}
              </div>
              <div
                className="px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  handle(27);
                }}
              >
                {t("LEADERBOARD")}
              </div>
              <div
                className="px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  handle(29);
                }}
              >
                ClockInSystem ({t("Manual")})
              </div>
              <div
                className="px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  handle(32);
                }}
              >
                ClockInSystem ({t("Automated")})
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  )
}
